module.exports = __webpack_public_path__ + "media/images/award-badges-pt-b8a2565fc8c9e22980471b11800cd7c3.svg";